module.exports = __webpack_public_path__ + "catalog/items/bathroom/Fancy-Bath/Fancy-Bath.svg";